import { createStore, applyMiddleware, compose } from 'redux'
import { browserHistory } from 'react-router'
import thunkMiddleware from 'redux-thunk'

import { reducer } from './modules'
import { middleware as analyticsMiddleware } from './analytics'
import { routerMiddleware } from 'react-router-redux'

const middleware = [
  routerMiddleware(browserHistory),
  thunkMiddleware,
  analyticsMiddleware,
]

export function configureStore(initialState, callback) {
  const store = createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )
  callback(store)
}
